

export default {

    schedules: {},
    appointments: {},
}
